// frontend/src/components/common/Skeleton.js
import React from 'react';

export default function Skeleton({ height = 16, width = "100%", style = {} }) {
  return <div className="skeleton" style={{ height, width, ...style }} />;
}

export function SkeletonCard({ rows = 3 }) {
  return (
    <div className="card">
      <Skeleton height={18} width="55%" style={{ marginBottom: 14 }} />
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={13} style={{ marginBottom: 8, width: i === rows - 1 ? "70%" : "100%" }} />
      ))}
    </div>
  );
}